// extracted by mini-css-extract-plugin
module.exports = {"slideCard":"usp-slide_slideCard__4mgwl"};